export const dataBreaks = [];
for (let i = 0; i <= 120; i += 1) {
  dataBreaks.push(i);
}
